"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLockChecked = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconLockChecked = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M3.648 22.85V8.35h3.05v-2c0-1.465.507-2.707 1.519-3.724C9.229 1.609 10.457 1.1 11.898 1.1c1.443 0 2.67.509 3.682 1.526s1.518 2.259 1.518 3.724v2h3.05v14.5h-16.5Zm2.15-2.15h12.2V10.5h-12.2v10.2Zm3.05-12.35h6.1v-2c0-.85-.296-1.58-.89-2.188a2.909 2.909 0 0 0-2.163-.912c-.848 0-1.567.304-2.16.912a3.026 3.026 0 0 0-.887 2.188v2Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "m10.954 18.873 5.828-5.829-1.544-1.544-4.284 4.285-2.16-2.16-1.544 1.544 3.704 3.704Z"
}));
exports.IconLockChecked = IconLockChecked;
//# sourceMappingURL=IconLockChecked.js.map